module.exports = {
      id: "play-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "images/sprites/ui.svg#play-usage",
      toString: function () {
        return this.url;
      }
    }